import { render } from "./NewsSection.vue?vue&type=template&id=a3bc3ef4"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"

import "./NewsSection.vue?vue&type=style&index=0&id=a3bc3ef4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__